import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Footer, Navbar } from './components';
import "./i18n";
import { NotFound } from './pages';
import { routes } from './routes';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Navbar />

        <main className="w-full mt-20">
          <Routes>
            {routes.map((i, index) => (
              <Route path={i.path} element={<i.element />} key={index} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;